<template>
  <div class="concentrator-loop-content" v-loading="loading">
    <div class="table-head">
      <div>
        <el-button type="primary" @click="manualSwitchControl(1, id, 1, '')" size="small">一键全开</el-button>
        <el-button type="info"  @click="manualSwitchControl(1, id, 0, '')" size="small" style="background-color: #4d5967;border-color: #4d5967;">一键全关</el-button>
      </div>
      <el-button icon="el-icon-refresh-right" type="primary" @click="refreshLoopPower()" size="small">刷新三相电</el-button>
      
    </div>
    <el-table
      :data="tableData"
      style="width: 100%"
      ref="table"
      :border="false"
      class="loop-table"
      >
      <el-table-column label="回路名称">
        <template slot-scope="scope">
          回路{{ scope.row.loop_number }}
        </template>
      </el-table-column>
      <el-table-column label="所属策略">
        <template slot-scope="scope">
          <span>{{ scope.row.strategy_name?scope.row.strategy_name:'暂无策略' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="回路状态" prop="circuit_status" align="center" sortable>
        <template slot-scope="scope">
          <i v-if="scope.row.ste" :class="scope.row.ste==1?'valuegreen':'valuered'"></i>
          <span>{{ steType[scope.row.ste] }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="绑定设备的类型" width="110">
        <template slot-scope="scope">
          <span>{{ deviceTypeList[scope.row.bind_type] }}</span>
        </template>
      </el-table-column> -->
      <el-table-column prop="bind_device" label="被绑定的设备-状态" width="200">
        <template slot-scope="scope">
          <div v-if="scope.row.device_status&&scope.row.device_status.length>0">
            {{ scope.row.device_status[0].number }} - <span :class="scope.row.circuit_status==1?'green':'red'">{{ steType[scope.row.circuit_status] }}</span>
          </div>
          <div v-else>暂无</div>
        </template>
      </el-table-column>
      <el-table-column label="电压(V)">
        <el-table-column
          prop="sensor.voltage.a"
          label="A"
          min-width="30">
        </el-table-column>
        <el-table-column
          prop="sensor.voltage.b"
          label="B"
          min-width="30">
        </el-table-column>
        <el-table-column
          prop="sensor.voltage.c"
          label="C"
          min-width="30">
        </el-table-column>
      </el-table-column>
      <el-table-column label="电流(A)">
        <el-table-column
          prop="sensor.current.a"
          label="A"
          min-width="30">
        </el-table-column>
        <el-table-column
          prop="sensor.current.b"
          label="B"
          min-width="30">
        </el-table-column>
        <el-table-column
          prop="sensor.current.c"
          label="C"
          min-width="30">
        </el-table-column>
      </el-table-column>
      <el-table-column label="功率(W)">
        <el-table-column
          prop="sensor.power.a"
          label="A"
          min-width="30">
        </el-table-column>
        <el-table-column
          prop="sensor.power.b"
          label="B"
          min-width="30">
        </el-table-column>
        <el-table-column
          prop="sensor.power.c"
          label="C"
          min-width="30">
        </el-table-column>
      </el-table-column>
      <el-table-column label="操作" prop="type">
        <template slot-scope="scope">
          <el-switch
            class="switch-texts"
            v-model="scope.row.circuit_status"
            :active-value="1"
            :inactive-value="2"
            active-text="开启"
            inactive-text="关闭"
            active-color="#2d8cf0"
            inactive-color="#4d5967"
            @change="manualSwitchControl(2, id, $event, scope.row.loop_number)"
          />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import concentratorApi from "@/api/concentrator/concentrator";
export default {
  name: "concentratorLoop",
  props: {
    id: {
      type: Number,
    },
  },
  data() {
    return {
      loading: false,
      deviceTypeList: ['暂无', 'mqtt', 'zigbee', 'lora', 'cat', 'plc'],
      steType: ['无', '开启', '关闭'],
      tableData: []
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    getTableData() {
      if(!this.id){
        return
      }
      this.loading = true;
      this.tableData = []
      concentratorApi.getLoopList(this.id).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          this.tableData = res.data.data;
        }
      });
    },
    refreshLoopPower() { //回路控制
      concentratorApi.loopPower(this.id).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("刷新成功");
          this.getTableData();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    manualSwitchControl(type, cids, switch_type, loop_ids){
      let new_switch = switch_type
      if(type==2){
        if(switch_type==2){
          new_switch = 0
        }
      }
      concentratorApi.manualSwitchCenter({
        type,
        cids,
        switch: new_switch,
        loop_ids
      }).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("下发成功")
          this.getTableData()
        } else {
          this.$message.error(res.data.message);
        }
      });
    }
  }
};
</script>
<style lang='less'>
.concentrator-loop-content {
  height: 540px;
  padding:0 20px;
  .table-head{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 10px;
    margin-top:-10px;
  }
  .el-table--mini th{
    padding: 10px 0;
  }

  .loop-table{
    border: 0 !important;
    td,th{
      border-right: 0 !important;
    }
    th, .el-table__fixed-right-patch{
      border-bottom: 0;
    }
    &::after,&::before{
      background-color: #fff !important;
    }
  }



}
</style>
